import { render, staticRenderFns } from "./Environments.vue?vue&type=template&id=700a5f55&scoped=true&"
import script from "./Environments.vue?vue&type=script&lang=js&"
export * from "./Environments.vue?vue&type=script&lang=js&"
import style0 from "./Environments.vue?vue&type=style&index=0&id=700a5f55&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700a5f55",
  null
  
)

export default component.exports